<template>
    <v-sheet class="d-flex align-center col-12 p-0">
        <slot name="actions">
            <slot name="left">
                <v-btn v-if="close === true" class="grey darken-1" color="grey" dark small @click="onClose">
                    <i class="fa fa-times mr-1"></i>
                    {{ t('default::button.close') }}
                </v-btn>
                <v-btn v-if="cancel === true" class="grey darken-1" color="grey" dark small @click="onCancel">
                    <i class="fa fa-times mr-1"></i>
                    {{ t('default::button.cancel') }}
                </v-btn>
            </slot>
            <v-spacer></v-spacer>
            <slot name="right">
                <v-btn v-if="save === true" :disabled="disabled" :loading="loading" color="primary" @click="onSave">
                    <i class="mdi-content-save"></i>
                    {{ t(saveButtonText) }}
                </v-btn>
            </slot>
        </slot>
    </v-sheet>
</template>

<script>
export default {
    props: {
        close: {
            type: Boolean,
            required: false,
            default: true,
        },
        cancel: {
            type: Boolean,
            required: false,
            default: false,
        },
        save: {
            type: Boolean,
            required: false,
            default: false,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        saveButtonText: {
            type: String,
            required: false,
            default: 'default::button.save',
        },
    },
    methods: {
        onSave() {
            this.$emit('save');
        },
        onCancel() {
            this.$emit('cancel');
        },
        onClose() {
            this.$emit('close');
        },
    },
};
</script>
